<label for="contractSelect" class="form-label">Contratti</label>
<select id="contractSelect" class="form-select" [value]="value()" [disabled]="disabled()" (change)="onSelectionChange($event)">
  <option value="">Tutti i Contratti</option>
  @for (contract of contractsResource.value(); track  $index) {
    <option [value]="contract">{{ contract }}</option>
  }
</select>